<h1>Appointment Listing</h1>

<xui-mat-date-time-picker [label]="'Appointment Time'"  [name]="'appointmentDate'" [processing]="saving" [parentForm]="form" (action)="saveAppointment()" class="col-sm-12" *xuiPermissionRequired="'Clinical.Appointments.Write'"></xui-mat-date-time-picker>
@if (loading()) {
  <xui-loading-spinner></xui-loading-spinner>
}
<div class="mat-card-list" *xuiPermissionRequired="'Clinical.Appointments.Read';">
  @if (hasAppointments) {
    @if (showGroupedView()) {
      <mat-accordion>
        @for (group of appointmentsByYear(); track group.year) {
          <mat-expansion-panel [expanded]="group.isExpanded" #panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ group.year }}
                @if (!panel.expanded) {
                  <span class="appointment-count">&nbsp;({{ group.appointments.length }})</span>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>
            @for (appointment of group.appointments; track appointment.id) {
              <mat-card class="compact">
                <mat-card-content class="pb-0 pt-2">
                  <app-appointment-widget [appointment]="appointment" [types]="appointmentTypes" class="w-100"></app-appointment-widget>
                </mat-card-content>
              </mat-card>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    } @else {
      @for (appointment of appointments(); track appointment.id) {
        <mat-card class="compact">
          <mat-card-content class="pb-0 pt-2">
            <app-appointment-widget [appointment]="appointment" [types]="appointmentTypes" class="w-100"></app-appointment-widget>
          </mat-card-content>
        </mat-card>
      }
    }
  } @else {
    <mat-card class="compact">
      <mat-card-content>No appointments have been created for this patient.</mat-card-content>
    </mat-card>
  }
</div>
